const capitalise = text => text.toLowerCase().charAt(0).toUpperCase() + text.substring(1)

export default capitalise
